import { ColumnType, Row } from "@asayinc/component-library";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";

import { IClassActionEvent } from "src/store/classActionEvent/types";

dayjs.extend(relativeTime);
dayjs.extend(utc);

export const ISSUER_CLASS_ACTION_EVENTS_COLUMNS = [
  "recordDateStart",
  "recordDateEnd",
  "claimsAdministrator",
  "caseDeadline",
  "created",
];

export type ColumnDataHelpers = {
  getSort: (sortKey: string) => "asc" | "desc" | undefined;
  onOrderingChange: (data: unknown, sortKey: string) => void;
};

export type IssuerClassActionEventsColumnData = {
  recordDateStart: ColumnType;
  recordDateEnd: ColumnType;
  claimsAdministrator: ColumnType;
  caseDeadline: ColumnType;
  created: ColumnType;
};

export function getColumns() {
  return ISSUER_CLASS_ACTION_EVENTS_COLUMNS;
}

export function getColumnData({
  getSort,
  onOrderingChange,
}: ColumnDataHelpers): IssuerClassActionEventsColumnData {
  return {
    recordDateStart: {
      sort: getSort("record_date_start"),
      sortFn: (data: unknown) => onOrderingChange(data, "record_date_start"),
      style: "text",
      title: "Record Date Start",
      tdBodyProps: {
        textProps: {
          weight: 600,
        },
      },
    },
    recordDateEnd: {
      sort: getSort("record_date_end"),
      sortFn: (data: unknown) => onOrderingChange(data, "record_date_end"),
      style: "text",
      title: "Record Date End",
    },
    claimsAdministrator: {
      style: "text",
      title: "Claims Administrator",
    },
    caseDeadline: {
      sort: getSort("source_provider_case_deadline"),
      sortFn: (data: unknown) =>
        onOrderingChange(data, "source_provider_case_deadline"),
      style: "text",
      title: "Case Deadline",
    },
    created: {
      sort: getSort("created"),
      sortFn: (data: unknown) => onOrderingChange(data, "created"),
      style: "text",
      title: "Created",
    },
  };
}

export function getRowData(
  events: IClassActionEvent[],
  onRowClick: (event: IClassActionEvent) => void
): Row[] {
  const handleRowClick = (data: unknown) => {
    const { event } = data as {
      event: IClassActionEvent;
      idx: string;
    };
    onRowClick(event);
  };

  return events.map((event, idx) => {
    const {
      id,
      recordDateStart,
      recordDateEnd,
      claimsAdministrator,
      sourceProviderCaseDeadline,
      created,
    } = event;

    return {
      id,
      data: { event, idx },
      rowData: {
        recordDateStart: {
          content: recordDateStart
            ? dayjs(recordDateStart).format("MM/DD/YYYY")
            : "-",
          clickHandler: handleRowClick,
        },
        recordDateEnd: {
          content: recordDateEnd
            ? dayjs(recordDateEnd).format("MM/DD/YYYY")
            : "-",
          clickHandler: handleRowClick,
        },
        claimsAdministrator: {
          content: claimsAdministrator?.name || "-",
          clickHandler: handleRowClick,
        },
        caseDeadline: {
          content: sourceProviderCaseDeadline
            ? dayjs(sourceProviderCaseDeadline).format("MM/DD/YYYY")
            : "-",
          clickHandler: handleRowClick,
        },
        created: {
          content: created ? dayjs(created).format("MM/DD/YYYY") : "-",
          clickHandler: handleRowClick,
        },
      },
    };
  });
}
